module.exports = __webpack_public_path__ + "img/painting.cc330932.jpg";